import {Loader} from "@googlemaps/js-api-loader";

const googleMapContainer = document.getElementById("googleMapContainer");

const loader = new Loader({
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  version: "weekly",
});

let googleMapControls;
let isLoadingGoogleMaps = false;

const handleInitMap = async () => {
  const latString = googleMapContainer.getAttribute("data-lat");
  const lngString = googleMapContainer.getAttribute("data-lng");
  const mapId = googleMapContainer.getAttribute("data-map-id");
  const showPin = googleMapContainer.getAttribute("data-show-pin") === "true";
  let radiusMiles = 0;

  try {
    radiusMiles = parseInt(googleMapContainer.getAttribute("data-range-miles"));
  } catch (e) {
    console.error(e);
  }

  if (!latString || !lngString || !mapId || googleMapControls || isLoadingGoogleMaps) return;

  const center = {lat: parseFloat(latString), lng: parseFloat(lngString)};
  isLoadingGoogleMaps = true;

  try {
    await loader.load();

    const {Map} = await google.maps.importLibrary("maps");

    googleMapContainer.classList.remove("animate-pulse");

    googleMapControls = new Map(googleMapContainer, {
      mapId,
      center,
      zoom: 6,
    });

    if (showPin) {
      const {AdvancedMarkerElement} = await google.maps.importLibrary("marker");

      new AdvancedMarkerElement({
        map: googleMapControls,
        position: center,
        title: "Title",
      });
    }

    if (radiusMiles) {
      const radiusMeters = radiusMiles * 1609.34; // Convert miles to meters

      const primaryBackground = document.querySelector("meta[name=\"primary-background\"]")?.getAttribute("content") || "#3472C6";

      new google.maps.Circle({
        map: googleMapControls,
        center: center,
        radius: radiusMeters, // Radius in meters
        fillColor: primaryBackground, // Fill color of the circle
        fillOpacity: 0.2,     // Opacity of the fill
        strokeColor: primaryBackground, // Border color
        strokeOpacity: 0.75,    // Border opacity
        strokeWeight: 2       // Border width in pixels
      });
    }

  } catch (e) {
    console.error(e);
  } finally {
    isLoadingGoogleMaps = false;
  }
};

if (googleMapContainer) handleInitMap();
